import { useTheme } from "@emotion/react";
import {
  Add,
  AutoAwesomeOutlined,
  Clear,
  ExpandMore,
  ListAltOutlined,
  Search,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import CardForm from "../../../../components/cardForm";
import ModalAnswerComponent from "../../../../components/forms/modalAnswer";
import SuggestionModalAnswerComponent from "../../../../components/forms/suggestionModalAnswer";
import api from "../../../../services/api";
import useStyles from "./styles";

import FormWoman from "../../../../components/artsPersonComponent/formWoman";
import InternoModalConfirmacaoSaida from "../../../../components/modalSaindoDaPagina";
export default function Formularios() {
  const [selectedForm, setSelectedForm] = useState({});
  const [buscarFormulario, setBuscarFormulario] = useState("");
  const [open, setOpen] = useState(false);
  const [allForms, setAllForms] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openUpdateStatus, setOpenUpdateStatus] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [updateLoad, setUpdateLoad] = useState(false);
  const [step, setStep] = useState(0);
  const [error, setError] = useState(null);
  const [newForm, setNewForm] = useState({
    title: "",
    questions: [{ id: uuidv4(), question: "", type: 0, position: 0 }],
  });

  // Sugestões States
  const [selectedSuggestionForm, setSelectedSuggestionForm] = useState({});
  const [buscarSuggestionFormulario, setBuscarSuggestionFormulario] =
    useState("");
  const [openSuggestion, setOpenSuggestion] = useState(false);
  const [openEditSuggestion, setOpenEditSuggestion] = useState(false);
  const [allSuggestionForms, setAllSuggestionForms] = useState([]);
  const [openDeleteSuggestionModal, setOpenDeleteSuggestionModal] =
    useState(false);
  const [openUpdateSuggestionStatus, setOpenUpdateSuggestionStatus] =
    useState(false);
  const [deleteSuggestionLoad, setDeleteSuggestionLoad] = useState(false);
  const [updateSuggestionLoad, setUpdateSuggestionLoad] = useState(false);
  const [stepSuggestion, setStepSuggestion] = useState(0);
  const [errorSuggestion, setErrorSuggestion] = useState(null);
  const [newSuggestionForm, setNewSuggestionForm] = useState({
    title: "",
    questions: [{ id: uuidv4(), question: "", type: 0, position: 0 }],
  });
  const [expandedSuggestion, setExpandedSuggestion] = useState(false);
  // Cada accordion busca só depois da primeira abertura.
  const [jaAbertoSuggestion, setJaAbertoSuggestion] = useState(false);
  const prevSuggestionLengthRef = useRef(newSuggestionForm?.questions?.length);

  const handleExpansionSuggestion = () => {
    setExpandedSuggestion((prev) => !prev);
    setJaAbertoSuggestion(true);
  };

  const [openEdit, setOpenEdit] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const theme = useTheme();
  const styles = useStyles(theme);
  const containerRef = useRef(null);
  const lastItemRef = useRef(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [jaAberto, setJaAberto] = useState(false);
  const prevLengthRef = useRef(newForm?.questions?.length);
  const stepsAdd = ["Novo formulário", "Pré-visualização"];
  const stepsEdit = ["Editar formulário", "Pré-visualização"];
  const deleteBody =
    "Se você prosseguir com a operação, o item e todas as informações associadas serão excluídas permanentemente!";
  const updateBody =
    "Atualizar o status do formulário irá alterar sua visibilidade e disponibilidade para os usuários. Tem certeza que deseja continuar?";
  const confirmDelete = "Excluir";
  const confirmUpdate = "Atualizar";

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
    setJaAberto(true);
  };
  useEffect(() => {
    const currentLength = newForm?.questions?.length;
    const previousLength = prevLengthRef?.current;

    if (currentLength > previousLength) {
      if (lastItemRef.current) {
        lastItemRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }

    // Atualiza o ref com o tamanho atual
    prevLengthRef.current = currentLength;
  }, [newForm.questions]);
  useEffect(() => {
    const currentLength = selectedForm?.questions?.length;
    const previousLength = prevLengthRef?.current;

    // Se foi adicionado um item
    if (currentLength > previousLength) {
      if (lastItemRef.current) {
        lastItemRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }

    // Atualiza o ref com o tamanho atual
    prevLengthRef.current = currentLength;
  }, [selectedForm.questions]);
  useEffect(() => {
    if (!jaAberto) return;
    findManyForms();
  }, [jaAberto]);

  const filteredRows = allForms?.filter((row) => {
    const search = buscarFormulario?.toLowerCase()?.trim() || "";
    return row?.title?.toLowerCase()?.includes(search);
  });
  const syncQuestionPositions = (questions) =>
    questions.map((q, index) => ({ ...q, position: index }));

  const filteredSuggestionRows = allSuggestionForms?.filter((row) => {
    const search = buscarSuggestionFormulario?.toLowerCase()?.trim() || "";
    return row?.title?.toLowerCase()?.includes(search);
  });

  useEffect(() => {
    const currentLength = newSuggestionForm?.questions?.length;
    const previousLength = prevSuggestionLengthRef?.current;
    if (currentLength > previousLength) {
      if (lastItemRef.current) {
        lastItemRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
    prevSuggestionLengthRef.current = currentLength;
  }, [newSuggestionForm.questions]);

  useEffect(() => {
    const currentLength = selectedSuggestionForm?.questions?.length;
    const previousLength = prevSuggestionLengthRef?.current;
    if (currentLength > previousLength) {
      if (lastItemRef.current) {
        lastItemRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
    prevSuggestionLengthRef.current = currentLength;
  }, [selectedSuggestionForm.questions]);

  useEffect(() => {
    if (!jaAbertoSuggestion) return;
    findManySuggestionForms();
  }, [jaAbertoSuggestion]);

  const handleOpen = () => setOpen(true);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleClose = () => {
    setError(null);
    setStep(0);
    setNewForm({
      title: "",
      questions: [{ id: uuidv4(), question: "", type: 0, position: 0 }],
    });
    setOpen(false);
  };
  const handleCloseEdit = () => {
    setError(null);
    setStep(0);
    setOpenEdit(false);
  };

  const handleQuestionChange = (id, prop, value) => {
    setNewForm((prev) => ({
      ...prev,
      questions: prev?.questions?.map((q) =>
        q.id === id ? { ...q, [prop]: value } : q,
      ),
    }));
  };

  const handleQuestionEditChange = (id, prop, value) => {
    setSelectedForm((prev) => ({
      ...prev,
      questions: prev?.questions?.map((q) =>
        q.id === id ? { ...q, [prop]: value } : q,
      ),
    }));
  };

  const handleAddQuestion = () => {
    setNewForm((prev) => {
      const newQuestion = {
        id: uuidv4(),
        question: "",
        type: 0,
        position: prev?.questions?.length,
      };

      const updatedQuestions = [...prev?.questions, newQuestion];
      return {
        ...prev,
        questions: syncQuestionPositions(updatedQuestions),
      };
    });
  };
  const handleAddQuestionEdit = () => {
    setSelectedForm((prev) => {
      const newQuestion = {
        id: uuidv4(),
        question: "",
        type: 0,
        position: prev?.questions?.length,
      };

      const updatedQuestions = [...prev?.questions, newQuestion];
      return {
        ...prev,
        questions: syncQuestionPositions(updatedQuestions),
      };
    });
  };
  const handleRemoveQuestion = (idToRemove) => {
    setNewForm((prev) => {
      const updatedQuestions = prev?.questions.filter(
        (q) => q.id !== idToRemove,
      );
      return {
        ...prev,
        questions: syncQuestionPositions(updatedQuestions),
      };
    });
  };

  const handleRemoveQuestionEdit = (idToRemove) => {
    setSelectedForm((prev) => {
      const updatedQuestions = prev?.questions.filter(
        (q) => q.id !== idToRemove,
      );
      return {
        ...prev,
        questions: syncQuestionPositions(updatedQuestions),
      };
    });
  };

  const createForm = async () => {
    if (!newForm?.title?.trim()) {
      setError(true);
      setSnackbar({
        children: "Por favor, preencha o título.",
        severity: "warning",
      });
      return;
    }
    if (newForm?.questions.some((q) => !q?.question?.trim())) {
      setError(true);
      setSnackbar({
        children: "Não é permitido perguntas em branco.",
        severity: "warning",
      });
      return;
    }
    if (newForm?.questions.some((q) => q?.type === 2 && !q?.options?.length)) {
      setError(true);
      setSnackbar({
        children: "Necessário adicionar opções para perguntas de seleção.",
        severity: "warning",
      });
      return;
    }
    try {
      const response = await api.post("/interno/create/form", {
        title: newForm.title?.trim(),
        questions: newForm.questions,
      });

      setAllForms((prev) => [...prev, response?.data]);
      setSnackbar({
        children: "Formulário criado com sucesso",
        severity: "success",
      });
      handleClose();
    } catch (error) {
      console.error("Error creating form:", error);
      setSnackbar({
        children: "Erro ao criar formulário",
        severity: "error",
      });
    } finally {
      setError(null);
      setStep(0);
    }
  };
  const findManyForms = async () => {
    try {
      const response = await api.get("/interno/findMany/forms", {
        title: newForm.title,
        questions: newForm.questions,
      });
      setAllForms(response?.data);
    } catch (error) {
      console.error("Error creating form:", error);
      setSnackbar({
        children: "Erro ao buscar formulários",
        severity: "error",
      });
    } finally {
    }
  };

  const deleteForm = async () => {
    try {
      setDeleteLoad(true);
      await api.post(`/interno/delete/form`, {
        idForm: selectedForm?.id,
      });

      setAllForms((prev) =>
        prev.filter((form) => form.id !== selectedForm?.id),
      );
      setSnackbar({
        children: "Formulário excluído com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting form:", error);
      setSnackbar({
        children: "Erro ao deletar formulário",
        severity: "error",
      });
    } finally {
      setSelectedForm({});
      setOpenDeleteModal(false);
      setDeleteLoad(false);
    }
  };

  const updateStatusForm = async () => {
    setUpdateLoad(true);

    try {
      const response = await api.post("/interno/updateStatus/form", {
        id: selectedForm?.id,
        status: !selectedForm?.status,
      });
      setAllForms((prev) =>
        prev?.map((form) =>
          form?.id === response?.data?.id
            ? { ...form, status: response?.data?.status }
            : {
                ...form,
                status: response?.data?.status === true ? false : form?.status,
              },
        ),
      );
      /* setAllForms(response?.data); */
      setSnackbar({
        children: "Status do formulário atualizado com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error("Error updating form status:", error);
      setSnackbar({
        children: "Erro ao atualizar status do formulário",
        severity: "error",
      });
    } finally {
      setOpenUpdateStatus(false);
      setUpdateLoad(false);
      setSelectedForm({});
    }
  };
  const updateForm = async () => {
    if (!selectedForm?.title?.trim()) {
      setError(true);
      setSnackbar({
        children: "Por favor, preencha o título.",
        severity: "warning",
      });
      return;
    }
    if (selectedForm?.questions.some((q) => !q?.question?.trim())) {
      setError(true);
      setSnackbar({
        children: "Não é permitido perguntas em branco.",
        severity: "warning",
      });
      return;
    }
    if (
      selectedForm?.questions.some((q) => q?.type === 2 && !q?.options?.length)
    ) {
      setError(true);
      setSnackbar({
        children: "Necessário adicionar opções para perguntas de seleção.",
        severity: "warning",
      });
      return;
    }
    try {
      setUpdateLoad(true);
      const response = await api.post("/interno/update/form", {
        id: selectedForm?.id,
        title: selectedForm?.title,
        questions: selectedForm?.questions,
      });
      setAllForms((prev) =>
        prev.map((form) =>
          form.id === response?.data?.id ? response?.data : form,
        ),
      );

      setSnackbar({
        children: "Status do formulário atualizado com sucesso",
        severity: "success",
      });
      handleCloseEdit();
    } catch (error) {
      console.error("Error updating form status:", error);
      setSnackbar({
        children: "Erro ao atualizar status do formulário",
        severity: "error",
      });
    } finally {
      setOpenUpdateStatus(false);
      setUpdateLoad(false);
      setSelectedForm({});
      setStep(0);
    }
  };

  const handleOpenSuggestion = () => setOpenSuggestion(true);
  const handleOpenEditSuggestion = () => setOpenEditSuggestion(true);

  const handleCloseSuggestion = () => {
    setErrorSuggestion(null);
    setStepSuggestion(0);
    setNewSuggestionForm({
      title: "",
      questions: [{ id: uuidv4(), question: "", type: 0, position: 0 }],
    });
    setOpenSuggestion(false);
  };

  const handleCloseEditSuggestion = () => {
    setErrorSuggestion(null);
    setStepSuggestion(0);
    setOpenEditSuggestion(false);
  };

  const handleQuestionChangeSuggestion = (id, prop, value) => {
    setNewSuggestionForm((prev) => ({
      ...prev,
      questions: prev?.questions?.map((q) =>
        q.id === id ? { ...q, [prop]: value } : q,
      ),
    }));
  };

  const handleQuestionEditChangeSuggestion = (id, prop, value) => {
    setSelectedSuggestionForm((prev) => ({
      ...prev,
      questions: prev?.questions?.map((q) =>
        q.id === id ? { ...q, [prop]: value } : q,
      ),
    }));
  };

  const handleAddQuestionSuggestion = () => {
    setNewSuggestionForm((prev) => {
      const newQuestion = {
        id: uuidv4(),
        question: "",
        type: 0,
        position: prev?.questions?.length,
      };
      const updatedQuestions = [...prev?.questions, newQuestion];
      return { ...prev, questions: syncQuestionPositions(updatedQuestions) };
    });
  };

  const handleAddQuestionEditSuggestion = () => {
    setSelectedSuggestionForm((prev) => {
      const newQuestion = {
        id: uuidv4(),
        question: "",
        type: 0,
        position: prev?.questions?.length,
      };
      const updatedQuestions = [...prev?.questions, newQuestion];
      return { ...prev, questions: syncQuestionPositions(updatedQuestions) };
    });
  };

  const handleRemoveQuestionSuggestion = (idToRemove) => {
    setNewSuggestionForm((prev) => {
      const updatedQuestions = prev?.questions.filter(
        (q) => q.id !== idToRemove,
      );
      return { ...prev, questions: syncQuestionPositions(updatedQuestions) };
    });
  };

  const handleRemoveQuestionEditSuggestion = (idToRemove) => {
    setSelectedSuggestionForm((prev) => {
      const updatedQuestions = prev?.questions.filter(
        (q) => q.id !== idToRemove,
      );
      return { ...prev, questions: syncQuestionPositions(updatedQuestions) };
    });
  };

  const createSuggestionForm = async () => {
    if (!newSuggestionForm?.title?.trim()) {
      setErrorSuggestion(true);
      setSnackbar({
        children: "Por favor, preencha o título.",
        severity: "warning",
      });
      return;
    }
    if (newSuggestionForm?.questions.some((q) => !q?.question?.trim())) {
      setErrorSuggestion(true);
      setSnackbar({
        children: "Não é permitido perguntas em branco.",
        severity: "warning",
      });
      return;
    }
    if (
      newSuggestionForm?.questions.some(
        (q) => q?.type === 2 && !q?.options?.length,
      )
    ) {
      setErrorSuggestion(true);
      setSnackbar({
        children: "Necessário adicionar opções para perguntas de seleção.",
        severity: "warning",
      });
      return;
    }
    try {
      const response = await api.post("/interno/create/suggestionForm", {
        title: newSuggestionForm.title?.trim(),
        questions: newSuggestionForm.questions,
      });
      setAllSuggestionForms((prev) => [...prev, response?.data]);
      setSnackbar({
        children: "Formulário de sugestão criado",
        severity: "success",
      });
      handleCloseSuggestion();
    } catch (error) {
      console.error("Error creating suggestion form:", error);
      setSnackbar({
        children: "Erro ao criar formulário de sugestão",
        severity: "error",
      });
    } finally {
      setErrorSuggestion(null);
      setStepSuggestion(0);
    }
  };

  const findManySuggestionForms = async () => {
    try {
      const response = await api.get("/interno/findMany/suggestionForm");
      setAllSuggestionForms(response?.data);
    } catch (error) {
      console.error("Error finding suggestion forms:", error);
    }
  };

  const deleteSuggestionForm = async () => {
    try {
      setDeleteSuggestionLoad(true);
      await api.post(`/interno/delete/suggestionForm`, {
        idForm: selectedSuggestionForm?.id,
      });
      setAllSuggestionForms((prev) =>
        prev.filter((form) => form.id !== selectedSuggestionForm?.id),
      );
      setSnackbar({
        children: "Formulário excluído com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting form:", error);
      setSnackbar({
        children: "Erro ao deletar formulário",
        severity: "error",
      });
    } finally {
      setSelectedSuggestionForm({});
      setOpenDeleteSuggestionModal(false);
      setDeleteSuggestionLoad(false);
    }
  };

  const updateStatusSuggestionForm = async () => {
    setUpdateSuggestionLoad(true);
    try {
      const response = await api.post("/interno/updateStatus/suggestionForm", {
        id: selectedSuggestionForm?.id,
        status: !selectedSuggestionForm?.status,
      });
      setAllSuggestionForms((prev) =>
        prev?.map((form) =>
          form?.id === response?.data?.id
            ? { ...form, status: response?.data?.status }
            : {
                ...form,
                status: response?.data?.status === true ? false : form?.status,
              },
        ),
      );
      setSnackbar({
        children: "Status atualizado com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error("Error updating form status:", error);
      setSnackbar({ children: "Erro ao atualizar status", severity: "error" });
    } finally {
      setOpenUpdateSuggestionStatus(false);
      setUpdateSuggestionLoad(false);
      setSelectedSuggestionForm({});
    }
  };

  const updateSuggestionForm = async () => {
    if (!selectedSuggestionForm?.title?.trim()) {
      setErrorSuggestion(true);
      setSnackbar({
        children: "Por favor, preencha o título.",
        severity: "warning",
      });
      return;
    }
    if (selectedSuggestionForm?.questions.some((q) => !q?.question?.trim())) {
      setErrorSuggestion(true);
      setSnackbar({
        children: "Não é permitido perguntas em branco.",
        severity: "warning",
      });
      return;
    }
    if (
      selectedSuggestionForm?.questions.some(
        (q) => q?.type === 2 && !q?.options?.length,
      )
    ) {
      setErrorSuggestion(true);
      setSnackbar({
        children: "Necessário adicionar opções para perguntas de seleção.",
        severity: "warning",
      });
      return;
    }
    try {
      setUpdateSuggestionLoad(true);
      const response = await api.post("/interno/update/suggestionForm", {
        id: selectedSuggestionForm?.id,
        title: selectedSuggestionForm?.title,
        questions: selectedSuggestionForm?.questions,
      });
      setAllSuggestionForms((prev) =>
        prev.map((form) =>
          form.id === response?.data?.id ? response?.data : form,
        ),
      );
      setSnackbar({
        children: "Formulário atualizado com sucesso",
        severity: "success",
      });
      handleCloseEditSuggestion();
    } catch (error) {
      console.error("Error updating form:", error);
      setSnackbar({
        children: "Erro ao atualizar formulário",
        severity: "error",
      });
    } finally {
      setOpenUpdateSuggestionStatus(false);
      setUpdateSuggestionLoad(false);
      setSelectedSuggestionForm({});
      setStepSuggestion(0);
    }
  };

  return (
    <>
      <Accordion data-secao="formularios" expanded={expanded} onChange={handleExpansion}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box sx={styles.containerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ListAltOutlined color="primary" />
              <Typography
                variant="h5"
                sx={{
                  ...styles.title,
                }}
              >
                Formulários de avaliação
              </Typography>
            </Box>
            {expanded && (
              <Box onClick={(e) => e.stopPropagation()} sx={styles.boxHeader}>
                <TextField
                  variant="outlined"
                  label="Buscar formulário"
                  placeholder="Buscar..."
                  value={buscarFormulario}
                  size="small"
                  autoComplete="off"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                  onChange={(event) => {
                    setBuscarFormulario(event.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: buscarFormulario ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setBuscarFormulario("")}
                          edge="end"
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={styles.searcField}
                />
                <Button
                  startIcon={<Add sx={styles.containerAdd} />}
                  onClick={() => setOpen(true)}
                  sx={styles.buttomAddUser}
                  variant="contained"
                >
                  Novo Formulário
                </Button>
              </Box>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={styles.container}>
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                spacing={2}
                columns={{ xs: 2, sm: 4, md: 4, lg: 6, xl: 6, xxl: 8 }}
                flexGrow={1}
              >
                {Array.isArray(filteredRows) &&
                  filteredRows.length > 0 &&
                  filteredRows.map((form) => (
                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                      {" "}
                      <CardForm
                        form={form}
                        deleteForm={deleteForm}
                        updateStatusForm={updateStatusForm}
                        setSelectedForm={setSelectedForm}
                        setOpenDeleteModal={setOpenDeleteModal}
                        setOpenUpdateStatus={setOpenUpdateStatus}
                        handleOpenEdit={handleOpenEdit}
                      />{" "}
                    </Grid>
                  ))}
                {filteredRows?.length === 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <FormWoman
                      mainFill={theme.palette.secondary.dark}
                      mainText={{
                        before: "Parece que ainda não\n" + "há ",
                        highlight: "formulários",
                        after: " por aqui.",
                      }}
                      subText={
                        "Os formulários aparecerão\n" +
                        "assim que forem criados"
                      }
                    />
                  </Box>
                )}
              </Grid>
            </Box>

            <ModalAnswerComponent
              open={open}
              handleClose={handleClose}
              newForm={newForm}
              setNewForm={setNewForm}
              error={error}
              setError={setError}
              createForm={createForm}
              handleAddQuestion={handleAddQuestion}
              handleRemoveQuestion={handleRemoveQuestion}
              containerRef={containerRef}
              lastItemRef={lastItemRef}
              styles={styles}
              handleQuestionChange={handleQuestionChange}
              stepsName={stepsAdd}
              setSnackbar={setSnackbar}
              setStep={setStep}
              step={step}
            />
            {/* ///////////////////////////////// */}
            <ModalAnswerComponent
              open={openEdit}
              handleClose={handleCloseEdit}
              newForm={selectedForm}
              setNewForm={setSelectedForm}
              error={error}
              setError={setError}
              createForm={updateForm}
              handleAddQuestion={handleAddQuestionEdit}
              handleRemoveQuestion={handleRemoveQuestionEdit}
              containerRef={containerRef}
              lastItemRef={lastItemRef}
              handleQuestionChange={handleQuestionEditChange}
              stepsName={stepsEdit}
              setSnackbar={setSnackbar}
              setStep={setStep}
              step={step}
            />
            <InternoModalConfirmacaoSaida
              openConfirmacao={openDeleteModal}
              load={deleteLoad}
              setOpenConfirmacao={setOpenDeleteModal}
              execute={() => {
                deleteForm();
              }}
              severity={"error"}
              title={"Atenção"}
              contentText={deleteBody}
              confirmText={confirmDelete}
            />
            <InternoModalConfirmacaoSaida
              openConfirmacao={openUpdateStatus}
              load={updateLoad}
              setOpenConfirmacao={setOpenUpdateStatus}
              execute={() => {
                updateStatusForm();
              }}
              severity={"warning"}
              title={"Atenção"}
              contentText={updateBody}
              confirmText={confirmUpdate}
            />
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion
        data-secao="sugestoes"
        expanded={expandedSuggestion}
        onChange={handleExpansionSuggestion}
      >
        <AccordionSummary expandIcon={<ExpandMore />} id="panel2-header">
          <Box sx={styles.containerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AutoAwesomeOutlined color="primary" />
              <Typography variant="h5" sx={{ ...styles.title }}>
                Sugestões de melhorias
              </Typography>
            </Box>
            {expandedSuggestion && (
              <Box onClick={(e) => e.stopPropagation()} sx={styles.boxHeader}>
                <TextField
                  variant="outlined"
                  label="Buscar formulário"
                  placeholder="Buscar..."
                  value={buscarSuggestionFormulario}
                  size="small"
                  autoComplete="off"
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                  onChange={(event) =>
                    setBuscarSuggestionFormulario(event.target.value)
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: buscarSuggestionFormulario ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setBuscarSuggestionFormulario("")}
                          edge="end"
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={styles.searcField}
                />
                <Button
                  startIcon={<Add sx={styles.containerAdd} />}
                  onClick={() => setOpenSuggestion(true)}
                  sx={styles.buttomAddUser}
                  variant="contained"
                >
                  Nova Sugestão
                </Button>
              </Box>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={styles.container}>
            <Box sx={{ width: "100%" }}>
              <Grid
                container
                spacing={2}
                columns={{ xs: 2, sm: 4, md: 4, lg: 6, xl: 6, xxl: 8 }}
                flexGrow={1}
              >
                {Array.isArray(filteredSuggestionRows) &&
                  filteredSuggestionRows.length > 0 &&
                  filteredSuggestionRows.map((form) => (
                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} key={form.id}>
                      <CardForm
                        form={form}
                        deleteForm={deleteSuggestionForm}
                        updateStatusForm={updateStatusSuggestionForm}
                        setSelectedForm={setSelectedSuggestionForm}
                        setOpenDeleteModal={setOpenDeleteSuggestionModal}
                        setOpenUpdateStatus={setOpenUpdateSuggestionStatus}
                        handleOpenEdit={handleOpenEditSuggestion}
                        isSuggestion={true}
                      />
                    </Grid>
                  ))}
                {filteredSuggestionRows?.length === 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <FormWoman
                      mainFill={theme.palette.secondary.dark}
                      mainText={{
                        before: "Parece que ainda não\nhá ",
                        highlight: "sugestões",
                        after: " por aqui.",
                      }}
                      subText={
                        "Crie um formulário de sugestão\npara receber ideias"
                      }
                    />
                  </Box>
                )}
              </Grid>
            </Box>

            <SuggestionModalAnswerComponent
              open={openSuggestion}
              handleClose={handleCloseSuggestion}
              newForm={newSuggestionForm}
              setNewForm={setNewSuggestionForm}
              error={errorSuggestion}
              setError={setErrorSuggestion}
              createForm={createSuggestionForm}
              handleAddQuestion={handleAddQuestionSuggestion}
              handleRemoveQuestion={handleRemoveQuestionSuggestion}
              containerRef={containerRef}
              lastItemRef={lastItemRef}
              styles={styles}
              handleQuestionChange={handleQuestionChangeSuggestion}
              stepsName={stepsAdd}
              setSnackbar={setSnackbar}
              setStep={setStepSuggestion}
              step={stepSuggestion}
            />

            <SuggestionModalAnswerComponent
              open={openEditSuggestion}
              handleClose={handleCloseEditSuggestion}
              newForm={selectedSuggestionForm}
              setNewForm={setSelectedSuggestionForm}
              error={errorSuggestion}
              setError={setErrorSuggestion}
              createForm={updateSuggestionForm}
              handleAddQuestion={handleAddQuestionEditSuggestion}
              handleRemoveQuestion={handleRemoveQuestionEditSuggestion}
              containerRef={containerRef}
              lastItemRef={lastItemRef}
              handleQuestionChange={handleQuestionEditChangeSuggestion}
              stepsName={stepsEdit}
              setSnackbar={setSnackbar}
              setStep={setStepSuggestion}
              step={stepSuggestion}
            />
            <InternoModalConfirmacaoSaida
              openConfirmacao={openDeleteSuggestionModal}
              load={deleteSuggestionLoad}
              setOpenConfirmacao={setOpenDeleteSuggestionModal}
              execute={() => deleteSuggestionForm()}
              severity={"error"}
              title={"Atenção"}
              contentText={deleteBody}
              confirmText={confirmDelete}
            />
            <InternoModalConfirmacaoSaida
              openConfirmacao={openUpdateSuggestionStatus}
              load={updateSuggestionLoad}
              setOpenConfirmacao={setOpenUpdateSuggestionStatus}
              execute={() => updateStatusSuggestionForm()}
              severity={"warning"}
              title={"Atenção"}
              contentText={updateBody}
              confirmText={confirmUpdate}
            />
          </Box>
        </AccordionDetails>
      </Accordion>

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
